import { jsPDF } from 'jspdf';
import { font } from "../../utlis/font/font";
import { getFormattedTodayDate } from "../../utlis/generalUtils";

export const downloadInvoicePDF = (order, profileData, logo, t, lang = 'en') => {
    const isRTL = lang === 'ar';
    const rtlOptions = isRTL ? { align: "right" } : {};

    const doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
        putOnlyUsedFonts: true,
    });

    // Font Setup
    doc.addFileToVFS('Amiri-Regular.ttf', font);
    doc.addFont('Amiri-Regular.ttf', 'Amiri', 'normal');
    doc.setFont("Amiri", "normal");

    // Top Bar
    doc.setFillColor(169, 169, 169);
    doc.rect(0, 0, 210, 5, 'F');

    // Title and Logo
    doc.setFontSize(18);
    doc.setTextColor(100);

    let title = '';
    let balanceDue = 0;
    if (order.status === "COMPLETED") {
        title = t('invoice_pdf.receipt');
    } else {
        title = t('invoice_pdf.invoice');
        balanceDue = order.amount;
    }
    doc.text(title, isRTL ? 200 : 10, 30, rtlOptions);

    const img = new Image();
    img.src = logo;
    doc.addImage(img, 'PNG', isRTL ? 20 : 160, 20, 30, 20);

    // Date and Receipt Number
    doc.setFontSize(8);
    doc.setTextColor(0);

    const positionX = isRTL ? 30 : 175;
    const positionAlign = "center";

    doc.text(t('invoice_pdf.date'), positionX, 50, { align: positionAlign });
    doc.text(t('invoice_pdf.receipt_no'), positionX, 64, { align: positionAlign });

    doc.setDrawColor(150);
    doc.line(positionX - 15, 52, positionX + 15, 52);
    doc.line(positionX - 15, 66, positionX + 15, 66);

    if (order.status === "COMPLETED") {
        doc.text(order.payment_date, positionX, 57, { align: positionAlign });
    } else {
        doc.text(getFormattedTodayDate(order.date), positionX, 57, { align: positionAlign });
    }
    doc.text(order.order_id ? order.order_id.toString() : "NA", positionX, 69, { align: positionAlign });

    // "FROM" Section
    doc.setFontSize(10);
    doc.setTextColor(150);
    doc.text(t('invoice_pdf.from'), isRTL ? 200 : 10, 70, rtlOptions);
    doc.line(isRTL ? 150 : 10, 72, isRTL ? 200 : 60, 72);
    doc.setTextColor(0);
    doc.setFont("Amiri", "bold");
    doc.text('YAIGLOBAL', isRTL ? 200 : 10, 78, rtlOptions);
    doc.setFont("Amiri", "normal");
    doc.text('Santa Clara, CA 95854, United States', isRTL ? 200 : 10, 83, rtlOptions);
    doc.text('5201 Great America Parkway', isRTL ? 200 : 10, 88, rtlOptions);

    // "TO" Section
    doc.setTextColor(150);
    doc.text(t('invoice_pdf.to'), isRTL ? 120 : 80, 70, rtlOptions);
    doc.line(isRTL ? 70 : 80, 72, isRTL ? 120 : 120, 72);
    doc.setTextColor(0);
    doc.text(order.payer_email || profileData?.email, isRTL ? 120 : 80, 78, rtlOptions);
    doc.text(profileData?.address || '', isRTL ? 120 : 80, 83, rtlOptions);
    doc.text(profileData?.phone || '', isRTL ? 120 : 80, 88, rtlOptions);

    // Table with article data
    const articleData = order.articles.map(article => [
        article.title, `$${order.amount}`
    ]);

    const headRow = isRTL
      ? [[t('invoice_pdf.total'), t('invoice_pdf.description')]]
      : [[t('invoice_pdf.description'), t('invoice_pdf.total')]];

    const bodyRows = articleData.length
      ? (isRTL ? articleData.map(row => [row[1], row[0]]) : articleData)
      : (isRTL ? [['0.00', t('invoice_pdf.no_items')]] : [[t('invoice_pdf.no_items'), '0.00']]);

    doc.autoTable({
        head: headRow,
        body: bodyRows,
        startY: 120,
        styles: {
            font: 'Amiri',
            fontStyle: 'normal',
            lineWidth: 0.2,
        },
        headStyles: {
            fillColor: [0, 0, 0],
            textColor: [255, 255, 255],
            fontSize: 10,
            halign: 'center',
        },
        bodyStyles: {
            font: 'Amiri',
            fontStyle: 'normal',
        },
        columnStyles: isRTL
          ? { 0: { halign: 'right' }, 1: { halign: 'right' } }
          : { 0: { halign: 'left' }, 1: { halign: 'right' } },
        theme: 'grid',
    });

    // Footer with dynamic totals
    const footerY = doc.lastAutoTable.finalY + 10;
    const labels = [t('invoice_pdf.subtotal')];
    const values = [`$${order.amount}`];

    doc.setFontSize(10);
    labels.forEach((label, index) => {
        const positionY = footerY + index * 10;
        doc.text(label, isRTL ? 200 : 140, positionY, rtlOptions);
        doc.text(values[index], 180, positionY, { align: 'right' });
    });

    doc.setLineWidth(0.5);
    doc.line(140, footerY + 15, 195, footerY + 15);

    // Balance Due Section
    doc.setFontSize(12);
    if (isRTL) {
        doc.text(`${t('invoice_pdf.balance_due')}   $${balanceDue}`, 200, footerY + 25, { align: "right" });
    } else {
        doc.text(t('invoice_pdf.balance_due'), 140, footerY + 25);
        doc.text(`$${balanceDue}`, 180, footerY + 25, { align: 'right' });
    }

    // Bottom Bar
    doc.setFillColor(169, 169, 169);
    const pageHeight = doc.internal.pageSize.height;
    doc.rect(0, pageHeight - 5, 210, 5, 'F');

    // Save PDF
    doc.save(`receipt_${order.order_id}.pdf`);
};

export const openTheEditor = (id, lang) => {
    window.open(`/${lang}/document?id=${id}&page=1`, "_blank");
}